<template>
  <v-container fluid class="bg-white">
    <template v-if="orders.loading">
      <v-skeleton-loader type="table-row-divider@3" />
    </template>
    <orders-table
      v-else
      :has-errors="orders.hasError"
      :items="orders.data.header"
      @refresh="getOrders"
    />
    <slider
      v-if="ui?.userFilter"
      :value="userFilter"
      :loading="ordersByUser.loading || orders.loading"
      :items="ordersByUser.data"
      :has-errors="ordersByUser.hasError"
      :disabled="ordersByUser.loading || orders.loading"
      @input="userFilter = $event"
    />
    <orders-details-table
      :loading="orders.loading"
      :items="filteredOrders"
      :has-errors="orders.hasError"
      @refreshOrders="getOrders"
    >
      <template v-if="ui?.userFilter" #table-header>
        <div class="mx-3 d-flex align-center">
          <span class="text-subtitle-2 text-nowrap">Filtrar:</span>
          <custom-select
            v-model="userFilter"
            :disabled="orders.loading || orders.hasError"
            :options="filteredUsersOptions"
            theme="red"
          />
        </div>
      </template>
    </orders-details-table>
    <order-rejection-glossary-modal />
    <confidentiality-notice class="mt-3" />
  </v-container>
</template>
<script scoped>
  import axios from '@/plugins/axios';
  import { mapGetters } from 'vuex';
  import roleConfig from './config/role-config';
  import ActiveUsernameMixin from '@/mixins/activeUsernameMixin';

  import ConfidentialityNotice from '@/components/ConfidentialityNotice.vue';

  import OrdersDetailsTable from './components/OrdersDetailsTable.vue';
  import OrdersTable from './components/OrdersTable.vue';
  import OrderRejectionGlossaryModal from './components/OrderRejectionGlossaryModal.vue';
  import CustomSelect from '@/components/CustomSelect.vue';

  import Slider from './UserSlider.vue';

  export default {
    name: 'OrderManagement',
    components: {
      Slider,
      ConfidentialityNotice,
      OrdersDetailsTable,
      OrdersTable,
      OrderRejectionGlossaryModal,
      CustomSelect,
    },
    mixins: [ActiveUsernameMixin],
    data() {
      return {
        loading: false,
        search: '',
        status: '',
        period: '1',
        glossary: {
          data: [],
          loading: false,
          modal: false,
        },
        orders: {
          data: [],
          loading: false,
          modal: false,
          hasError: false,
        },
        ordersByUser: {
          data: [],
          loading: false,
          hasError: false,
        },
        defaultUserOption: { value: -1, label: 'Todos' },
        userFilter: -1,
      };
    },
    computed: {
      ...mapGetters({
        user: 'auth/user',
      }),
      filteredUsersOptions() {
        return [this.defaultUserOption, ...this.ordersByUser.data];
      },
      filteredOrders() {
        if (this.orders.data.data) {
          if (this.userFilter === -1) {
            return this.orders.data.data;
          }
          return this.orders.data.data.filter(
            (order) => order[this.config.data.filterField] === this.userFilter
          );
        }
        return this.orders.data.data;
      },
      config() {
        return roleConfig[this.$route.meta.role];
      },
      ui() {
        return this.config.ui;
      },
    },
    created() {
      if (this.ui?.userFilter) {
        this.getOrdersByUser();
      }
      this.getOrders();
    },
    methods: {
      async getOrdersByUser() {
        this.ordersByUser.loading = true;
        this.ordersByUser.data = [];
        try {
          const params = {
            user: this.activeUsername.username,
            channel: this.user.VTWEG,
          };
          const res = await axios.get('/order-management/users', {
            params,
          });
          this.ordersByUser.data = res.data.data;
          this.userFilter = -1; // this.ordersByUser.data[0]?.value || -1;
          this.ordersByUser.hasError = false;
        } catch (error) {
          this.ordersByUser.hasError = true;
          this.$toast.error('Error al obtener la información de usuarios');
        }
        this.ordersByUser.loading = false;
      },
      async getOrders(username) {
        this.orders.loading = true;
        this.orders.data = [];
        const params = {
          user: username || this.activeUsername.username,
          channel: this.user.VTWEG,
        };
        try {
          const res = await axios.get('/order-management/orders', {
            params,
          });
          this.orders.data = res.data;
          this.orders.hasError = false;
        } catch (error) {
          this.orders.hasError = true;
          this.$toast.error('Error al obtener el listado de pedidos');
        }
        this.orders.loading = false;
      },
    },
  };
</script>
